'use strict';

var sleeknote = sleeknote || {};

sleeknote.stickyfloat = sleeknote.stickyfloat || function () {


    function init() {
        // Init functions
        floatIt();
        floatingTableHeaders();
    }

    function floatIt() {

        $(document).ready(function(){

                if( $('.sticky-float-js').length ){

                    if( $(window).width() > 1105 ) {

                        $('.sticky-float-js').each(function(){
                            
                            $(this).stick_in_parent({
                                offset_top: 140
                            });

                        });

                    }

                }
        
        });
    }

    function floatingTableHeaders(){

        if( $('.with-headers').length ){
                    
            var featureTableHeaders = $('.feature-table-headers'),
                negative_offset = (window.innerWidth < 992) ? 80 : 96,
                featureTableTop = $('.with-headers').offset().top - negative_offset; // Height of mainnavigation

            if ( $(document).scrollTop() >= featureTableTop ) {
                featureTableHeaders.addClass('scrolled');
            } else {
                featureTableHeaders.removeClass('scrolled');
            }

        }
    }

    $(document).scroll(function() {

        floatingTableHeaders();
        
    });

    return {
        init:init
    };

}();